import React, { useState } from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField } from "@mui/material";
import { cambiarClave } from "../services/usuarioService";
import { notifySuccess } from "../services/notificationService";

const LONGITUD_MINIMA = 8;

const CambiarClave = ({ open, onClose }) => {
    const [claveActual, setClaveActual] = useState("");
    const [claveNueva, setClaveNueva] = useState("");
    const [confirmacion, setConfirmacion] = useState("");
    const [error, setError] = useState("");
    const [guardando, setGuardando] = useState(false);

    const cerrar = () => {
        setClaveActual("");
        setClaveNueva("");
        setConfirmacion("");
        setError("");
        onClose();
    };

    const validar = () => {
        if (!claveActual || !claveNueva || !confirmacion) {
            return "Complete los tres campos.";
        }
        if (claveNueva.length < LONGITUD_MINIMA) {
            return `La clave nueva debe tener al menos ${LONGITUD_MINIMA} caracteres.`;
        }
        if (claveNueva !== confirmacion) {
            return "La confirmación no coincide con la clave nueva.";
        }
        if (claveNueva === claveActual) {
            return "La clave nueva debe ser distinta de la actual.";
        }
        return "";
    };

    const guardar = async (event) => {
        event.preventDefault();
        const mensaje = validar();
        if (mensaje) {
            setError(mensaje);
            return;
        }

        setGuardando(true);
        setError("");
        try {
            await cambiarClave(claveActual, claveNueva);
            notifySuccess("La clave se cambió correctamente.");
            cerrar();
        } catch (e) {
            if (e.response?.status === 400) {
                setError(e.response.data?.mensaje ?? "No se pudo cambiar la clave.");
            }
        } finally {
            setGuardando(false);
        }
    };

    return (
        <Dialog open={open} onClose={cerrar} fullWidth maxWidth="xs">
            <form onSubmit={guardar} noValidate>
                <DialogTitle>Cambiar clave</DialogTitle>
                <DialogContent>
                    <Stack spacing={2} sx={{ mt: 1 }}>
                        {error && <Alert severity="error">{error}</Alert>}
                        <TextField
                            label="Clave actual"
                            type="password"
                            autoComplete="current-password"
                            value={claveActual}
                            onChange={(e) => setClaveActual(e.target.value)}
                            autoFocus
                            fullWidth
                        />
                        <TextField
                            label="Clave nueva"
                            type="password"
                            autoComplete="new-password"
                            value={claveNueva}
                            onChange={(e) => setClaveNueva(e.target.value)}
                            helperText={`Al menos ${LONGITUD_MINIMA} caracteres.`}
                            fullWidth
                        />
                        <TextField
                            label="Repita la clave nueva"
                            type="password"
                            autoComplete="new-password"
                            value={confirmacion}
                            onChange={(e) => setConfirmacion(e.target.value)}
                            fullWidth
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={cerrar} disabled={guardando}>Cancelar</Button>
                    <Button type="submit" variant="contained" disabled={guardando}>Guardar</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default CambiarClave;
